import './styles.scss';
import { ProductComponentLibraryOrchestration } from './product-component-library/product-component-library.js';
import { USIntermediaryUrlLoadOrchestration } from './utilities/url-load/url-load.us-intermediary.js';
import { FootnoteIndicatorOrchestration } from './utilities/disclaimers/footnote-indicator.js';
import { BeaconOrchestration } from './beacon/beacon.js';
import { Constants, Defaults } from './common/constants.js';
import { Attestation } from './attestation/attestation.js';
import { extractFinancialIntermediaryDetails } from './common/helper.js';

// Set the defaults for the window configuration if they are not already set
window[Constants.POP_CONFIGURATION] = window[Constants.POP_CONFIGURATION] || {
  assetsDomain: Defaults.ASSETS_DOMAIN,
  dadaEndpoint: Defaults.DADA_ENDPOINT,
  dadaApiKey: Defaults.DADA_APIKEY,
  ivsEndpoint: Defaults.IVS_ENDPOINT,
  ivsApiKey: Defaults.IVS_APIKEY,
  dsUiLibraryVersion: Defaults.DS_UI_LIBRARY_VERSION,
  productComponentLibraryVersion: Defaults.PRODUCT_COMPONENT_LIBRARY_VERSION,
  beaconVersion: Defaults.BEACON_VERSION,
  beaconProjectName: Defaults.BEACON_PROJECT_NAME,
  beaconSkip: Defaults.BEACON_SKIP,
  popSkip: Defaults.POP_SKIP,
  country: Defaults.COUNTRY,
  language: Defaults.LANGUAGE,
};

const footnoteIndicatorOrchestration = new FootnoteIndicatorOrchestration();
footnoteIndicatorOrchestration.loadFootnoteIndicatorService();

const productComponentLibraryOrchestration =
  new ProductComponentLibraryOrchestration();
productComponentLibraryOrchestration.loadProductComponentLibrary();

const usIntermediaryUrlLoadOrchestration =
  new USIntermediaryUrlLoadOrchestration();
usIntermediaryUrlLoadOrchestration.createCallback();

const beaconOrchestration = new BeaconOrchestration();
beaconOrchestration.loadBeacon();

const { isFinancialIntermediary, country, language } =
  extractFinancialIntermediaryDetails();
const applyFinancialIntermediarySettings =
  isFinancialIntermediary && country && language;
const NO_ATTESTATION_COUNTRIES = ['us'];
if (
  !NO_ATTESTATION_COUNTRIES.includes(country) &&
  applyFinancialIntermediarySettings
) {
  const attestation = new Attestation();
  attestation.generateAttestation(country, language);
}
